import { TASK_TYPE_LABELS, type TaskType } from "@/lib/tasks";

export function TaskTypeBadge({ taskType }: { taskType: TaskType }) {
  return <span>{TASK_TYPE_LABELS[taskType]}</span>;
}
